import * as React from 'react';
import { ArticleHeading1 } from '@cian/ui-kit';

interface IAdditionalServicePriceProps {
  className?: string;
  price: string;
}

export const AdditionalServicePrice: React.FC<React.PropsWithChildren<IAdditionalServicePriceProps>> = ({
  className,
  price,
}) => {
  return (
    <div className={className} aria-label="Цена">
      <ArticleHeading1>{price}</ArticleHeading1>
    </div>
  );
};
